<script>
    import { createEventDispatcher } from 'svelte';
    import { navigate } from 'svelte-routing';

    export let tasks = [];
    export let currentMonth = new Date();

    const dispatch = createEventDispatcher();

    function evClassForVid(vid) {
        switch (String(vid)) {
            case '16': return 'cal-event-new';
            case '21': return 'cal-event-inwork';
            case '22': case '24': return 'cal-event-done';
            default: return 'cal-event-default';
        }
    }



    function daysInMonth() {
        const { from, to } = monthRange(currentMonth);
        const days = [];
        for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
            days.push(new Date(d));
        }
        return days;
    }



    // ВАЖНО: используем item.data, а не item.dataDo
    function tasksForDay(day) {
        return tasks.filter(t => {
            const td = toDate(t.data);
            return td.getDate() === day.getDate() &&
                td.getMonth() === day.getMonth() &&
                td.getFullYear() === day.getFullYear();
        });
    }

    function prevMonth() {
        currentMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1);
        dispatch('monthChange', { month: currentMonth });
    }

    function nextMonth() {
        currentMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
        dispatch('monthChange', { month: currentMonth });
    }

    function isToday(d) {
        const t = new Date();
        return d.getDate() === t.getDate() && d.getMonth() === t.getMonth() && d.getFullYear() === t.getFullYear();
    }

    function openTask(t) {
        navigate(`/order/${t.nomer}/${t.vid ?? 16}`);
    }

    $: monthLabel = currentMonth.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' });




    function monthRange(date) {
        const from = new Date(date.getFullYear(), date.getMonth(), 1);
        const to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return { from, to };
    }



    function buildDaysInMonth(date) {
        const { from, to } = monthRange(date);
        const days = [];
        for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
            days.push(new Date(d));
        }
        return days;
    }

    function toDate(v) {
        return v instanceof Date ? v : new Date(v);
    }

    function buildTasksForDay(day, taskList) {
        return taskList.filter(t => {
            const td = toDate(t.data ?? t.dataDo);
            return td.getDate() === day.getDate() &&
                td.getMonth() === day.getMonth() &&
                td.getFullYear() === day.getFullYear();
        });
    }

    // Явно указываем зависимости в самом реактивном выражении
    $: days = buildDaysInMonth(currentMonth);
    $: dayGroups = days.map(day => ({ day, tasks: buildTasksForDay(day, tasks) }));
</script>

<div class="cal-nav">
    <button class="cal-nav-btn" on:click={prevMonth}>‹</button>
    <span class="cal-month-label">{monthLabel}</span>
    <button class="cal-nav-btn" on:click={nextMonth}>›</button>
</div>

<div class="cal-day-list">
    {#each dayGroups as { day, tasks: dayTasks }}
        <div class="cal-day-row {isToday(day) ? 'today' : ''}">
            <div class="cal-day-num">{day.getDate()}</div>
            <div class="cal-day-tasks">
                {#if dayTasks.length === 0}
                    <span class="cal-empty">—</span>
                {:else}
                    {#each dayTasks as t}
                        <div class="cal-event {evClassForVid(t.vid)}" on:click={() => openTask(t)}>
                            №{t.nomer} · {t.tipIzd || t.tovarName || ''}
                        </div>
                    {/each}
                {/if}
            </div>
        </div>
    {/each}
</div>

<style>
    .cal-nav { display: flex; align-items: center; justify-content: center; gap: 16px; padding: 10px 0; }
    .cal-nav-btn { background: none; border: none; font-size: 20px; color: #0b7285; cursor: pointer; width: 32px; height: 32px; }
    .cal-month-label { font-weight: 600; font-size: 15px; text-transform: capitalize; min-width: 140px; text-align: center; }
    .cal-day-list { display: flex; flex-direction: column; }
    .cal-day-row { display: flex; border-bottom: 1px solid #eef0f3; padding: 8px 12px; gap: 10px; }
    .cal-day-row.today { background: #fff8f0; }
    .cal-day-num { width: 28px; height: 28px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; border-radius: 50%; font-weight: 600; font-size: 13px; color: #2d3748; }
    .today .cal-day-num { background: #FF6B35; color: #fff; }
    .cal-day-tasks { display: flex; flex-direction: column; gap: 4px; flex: 1; min-width: 0; }
    .cal-empty { color: #c0c8d0; font-size: 12px; }
    .cal-event { padding: 5px 9px; border-radius: 6px; font-size: 12px; font-weight: 500; cursor: pointer; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
    .cal-event-new { background: #42a5f5; color: #0e0d0d; border-left: 3px solid #1976D2; }
    .cal-event-inwork { background: #66bb6a; color: #fff; border-left: 3px solid #43A047; }
    .cal-event-done { background: #d4e157; color: #0e0d0d; border-left: 3px solid #aab347; }
    .cal-event-default { background: #EDE7F6; color: #4527A0; border-left: 3px solid #5E35B1; }
</style>